export default __webpack_public_path__ + "static/media/lightHeart.f0c82843.svg";